module.exports = "/images/body-back.svg?196274582989dff00a627243dc2c4732";